/***************/
/**  IMPORTS  **/
/***************/
import { useState } from 'react';
import Cookies from "universal-cookie";
import { RiCloseLine } from "react-icons/ri";

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';
import { get, post } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { 
    DarkBG,
    Centered,
    TheModal,
    ModalHeader,
    Heading,
    ModalContent,
    CloseButton,
} from '../styles/EditUserModalStyles';
import { 
    Toggle,
    } from "../styles/NotificationsPageStyles";


export default function EditUserModal({ user, setOpenEditModal }){

    var email_toggle;
    var text_toggle;
    console.log(user);
    if(user.email_alerts){
        email_toggle = "ON";
    } else {
        email_toggle = "OFF";
    }
    if(user.text_alerts){
        text_toggle = "ON";
    } else {
        text_toggle = "OFF";
    }
    const [emailToggle, setEmailToggle] = useState(email_toggle);
    const [textToggle, setTextToggle] = useState(text_toggle);

    const cookies = new Cookies();
    const token = cookies.get("TOKEN");

    Amplify.configure(amplifyconfig);

    async function getUserDetails(){
        try{
            const email = localStorage.getItem("EMAIL");
            const account = get({
                apiName: 'UserAPI',
                    path: `/user/get-user-info?email=${encodeURIComponent(email)}`,
                    options: {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    }
            });
    
            const { body } = await account.response;
            const res = await body.json();
            console.log("User details GET call succeeded");
            email_toggle = res.email_toggle ? "ON" : "OFF";
            text_toggle = res.text_toggle ? "ON" : "OFF";
            setEmailToggle(email_toggle);
            setTextToggle(text_toggle);
        } catch(e){
            console.log('User details GET call failed: ', e);
        }
      }

    /**  HANDLES TOGGLING THE EMAIL ALERTS ON/OFF  **/
    const handleEmailToggle = async (email_toggle) => {
        
        const email = user.email;
        try {
            setEmailToggle(email_toggle);
            const tog = email_toggle === "ON" ? true : false;

            const toggle = post({
                apiName: 'UserAPI',
                path: '/user/toggle_email_alerts',
                options: {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    body: {
                        tog,
                        email,
                    },
                }
            });

            const { body } = await toggle.response;
            const res = await body.json();
            console.log('Toggling email alerts POST call succeeded');
            await getUserDetails();

        } catch (e) {
            console.log('Toggling email alerts POST call failed: ', e);
        }
    };

    /**  HANDLES TOGGLING THE EMAIL ALERTS ON/OFF  **/
    const handleTextToggle = async (text_toggle) => {
        
        const email = user.email;
        try {
            setTextToggle(text_toggle);
            const tog = text_toggle === "ON" ? true : false;
            const toggle = post({
                apiName: 'UserAPI',
                path: '/user/toggle_text_alerts',
                options: {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    body: {
                        tog,
                        email,
                    },
                }
            });

            const { body } = await toggle.response;
            const res = await body.json();
            console.log('Toggling text alerts POST call succeeded');
            await getUserDetails();
        } catch (e) {
            console.log('Toggling text alerts POST call failed: ', e);
        }
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setOpenEditModal(false);
        document.body.style.overflow = 'unset';
    }

    const editUser = (e) => {
        e.stopPropagation();
    };

    const approveUser = (e) => {
        e.stopPropagation();
    };

    const deleteUser = (e) => {
        e.stopPropagation();
    };

    return (
        <>
            <DarkBG onClick={() => {
                setOpenEditModal(false);
                document.body.style.overflow = 'unset';
                }} />
            <Centered>
                <TheModal>
                    <ModalHeader>
                        <Heading>{user.first_name} {user.last_name}'s Notification Settings</Heading>
                    </ModalHeader>
                    <CloseButton onClick={(e) => handleClose(e)}>
                            <RiCloseLine style={{height: "15px"}}/>
                        </CloseButton>
                    <ModalContent>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "20px"}}>
                                <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "100px"}}>
                                    Email Alerts
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Toggle
                                        toggle={emailToggle === "ON"}
                                        onClick={() => {handleEmailToggle("ON")}}>
                                        ON
                                    </Toggle>
                                    
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Toggle
                                        toggle={emailToggle === "OFF"}
                                        onClick={() => {handleEmailToggle("OFF")}}>
                                        OFF
                                    </Toggle>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
                                <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "100px"}}>
                                    Text Alerts
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Toggle
                                        toggle={textToggle === "ON"}
                                        onClick={() => handleTextToggle("ON")}>
                                        ON
                                    </Toggle>
                                    
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                <Toggle
                                        toggle={textToggle === "OFF"}
                                        onClick={() => handleTextToggle("OFF")}>
                                        OFF
                                    </Toggle>
                                </div>
                            </div>
                    </ModalContent>
                </TheModal>
            </Centered>
        </>
    )
}